import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import Messages from "../../../constants/Messages";
import uRLs from "../../../utils/baseUtils";
import { useShowAlert } from "../../../context/AlertContext";
import { useNetwork } from "../../../context/NetworkContext";
import { useAuth } from "../../../context/AuthProvider";
import { ChevronLeftIcon } from "../../../constants/Icons";

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const showAlert = useShowAlert();
    const { checkNetwork } = useNetwork();
    const { handleLogin } = useAuth();

    const userNameInputRef = useRef(null);
    const passwordInputRef = useRef(null);
    const [isBtnLoading, setBtnLoading] = useState(false);

    const [isLoginData, setLoginData] = useState({ userName: '', password: '' });
    const [error, setErrors] = useState({});
    const [errorMsg, setErrorMsg] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    const validateForm = () => {
        const errors = {};
        if (isLoginData.userName === undefined || isLoginData.userName === null || isLoginData.userName === "") {
            errors.userName = Messages.ERROR.USER_NAME_EMPTY;
        } else if (isLoginData.password === undefined || isLoginData.password === null || isLoginData.password === "") {
            errors.password = Messages.ERROR.PASSWORD_EMPTY;
        }
        setErrors(errors);
        if (Object.keys(errors).length > 0) {
            const firstErrorField = Object.keys(errors)[0];
            switch (firstErrorField) {
                case 'userName':
                    userNameInputRef.current?.focus();
                    break;
                case 'password':
                    passwordInputRef.current?.focus();
                    break;
                default:
                    break;
            }
        }
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const cleanedValue = (name === 'userName') ? value.replace(/\s/g, '').trim().toLowerCase() : value;
        const updatedData = {
            ...isLoginData,
            [name]: cleanedValue,
        };
        setLoginData(updatedData);
    };

    const handleSignIn = () => {
        setErrorMsg(null);
        if (!validateForm()) return;
        handleAuthStaff();
    };

    const handleAuthStaff = async () => {
        setBtnLoading(true);
        try {
            if (!checkNetwork()) return;
            const response = await axios.post(`${uRLs.API_URL}module/auth/auth-staff`, isLoginData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (response.status === 201 && response.data.results.accessToken) {
                handleLogin(response.data.results);
                showAlert("success", Messages.AUTH.LOGIN_SUCCESS);
                navigate(`/dashboard`, { replace: true, state: null });
            }
        } catch (error) {
            setErrorMsg(error.response?.data?.message || Messages.ERROR.UNKNOWN_ERROR);
        } finally {
            setBtnLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSignIn();
        }
    };

    return (

        <div class="wrapper">
            <div class="authentication-reset-password d-flex align-items-center justify-content-center">
                <div class="container">
                    <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
                        <div class="col mx-auto">
                            <div class="card">
                                <div class="card-body">
                                    <div class="p-4">
                                        <div class="mb-4 text-center">
                                            <img src="assets/images/logo-icon.png" width="60" alt="" />
                                        </div>
                                        <div class="text-center mb-4">
                                            <h4 className="text-center mt-3 fw-400">Staff Login 🧑‍💻</h4>
                                            <p className="text-center mb-0">Enter your username and password to login</p>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label htmlFor="username" className="form-label">
                                                    Username <span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="userName"
                                                    autoComplete="off"
                                                    value={isLoginData.userName}
                                                    onChange={handleChange}
                                                    onKeyDown={handleKeyDown}
                                                    ref={userNameInputRef}
                                                />
                                                {error.userName && <div className="invalid-feedback">{error.userName}</div>}
                                            </div>

                                            <div className="col-12">
                                                <label htmlFor="password" className="form-label">
                                                    Password <span className="text-danger"> *</span>
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control"
                                                        name="password"
                                                        autoComplete="off"
                                                        value={isLoginData.password}
                                                        onChange={handleChange}
                                                        onKeyDown={handleKeyDown}
                                                        ref={passwordInputRef}
                                                    />
                                                    <span
                                                        className="input-group-text bg-transparent"
                                                        onClick={togglePasswordVisibility}>
                                                        <i className={`bx ${showPassword ? "bx-show" : "bx-hide"}`} ></i>
                                                    </span>
                                                </div>
                                                {error.password && <div className="invalid-feedback">{error.password}</div>}
                                            </div>

                                            {errorMsg && <div className="invalid-feedback">{errorMsg}</div>}

                                            <div className="col-12 mt-3">
                                                <div className="d-grid">
                                                    {isBtnLoading ? (
                                                        <button className="btn btn-primary pb-0" disabled>
                                                            <CircularProgress size={22} className="text-white" />
                                                        </button>
                                                    ) : (
                                                        <button type="button" onClick={handleSignIn} className="btn btn-primary w-100">
                                                            Log In
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div class="text-center">
                                                    <Link to="/login" class="d-flex align-items-center justify-content-center">
                                                        <ChevronLeftIcon iClass={"me-1 fs-18"}/>
                                                        Back to Login
                                                    </Link>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;